document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(
    ".header__linklist-item.has-dropdown"
  );

  function closeAllMenus(exceptItem = null) {
    menuItems.forEach(function (item) {
      if (item === exceptItem) return;

      const trigger = item.querySelector(".header__linklist-link[aria-controls]");
      const menu = trigger
        ? document.getElementById(trigger.getAttribute("aria-controls"))
        : null;

      if (trigger && menu) {
        trigger.setAttribute("aria-expanded", "false");
        menu.setAttribute("hidden", "");
      }
    });
  }

  function openMenu(item) {
    const trigger = item.querySelector(".header__linklist-link[aria-controls]");
    if (!trigger) return;

    const menu = document.getElementById(trigger.getAttribute("aria-controls"));
    if (!menu) return;

    closeAllMenus(item);
    trigger.setAttribute("aria-expanded", "true");
    menu.removeAttribute("hidden");
  }

  function closeMenu(item) {
    const trigger = item.querySelector(".header__linklist-link[aria-controls]");
    if (!trigger) return;

    const menu = document.getElementById(trigger.getAttribute("aria-controls"));
    if (!menu) return;

    trigger.setAttribute("aria-expanded", "false");
    menu.setAttribute("hidden", "");
  }

  function toggleMenu(item) {
    const trigger = item.querySelector(".header__linklist-link[aria-controls]");
    if (!trigger) return;

    const isExpanded = trigger.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      closeMenu(item);
    } else {
      openMenu(item);
    }
  }

  menuItems.forEach(function (item) {
    const trigger = item.querySelector(".header__linklist-link[aria-controls]");
    if (!trigger) return;

    const menu = document.getElementById(trigger.getAttribute("aria-controls"));
    if (!menu) return;

    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");

    // Mouse hover
    item.addEventListener("mouseenter", function () {
      openMenu(item);
    });

    item.addEventListener("mouseleave", function () {
      closeMenu(item);
    });

    // Mouse click works as normal link
    trigger.addEventListener("click", function () {
      // no preventDefault here
    });

    // Keyboard Enter / Space toggles dropdown only
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleMenu(item);
      }

      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu(item);
      }
    });

    menu.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu(item);
        trigger.focus();
      }
    });

    item.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          closeMenu(item);
        }
      }, 100);
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".header__linklist-item.has-dropdown")) {
      closeAllMenus();
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const searchInput = document.querySelector("#wtb-search-input");
    
    if (searchInput) {
      searchInput.setAttribute("aria-label", "Search");
    }
  }, 2000); 
});

document.addEventListener("DOMContentLoaded", function () {
  const excludedLinks = [
    'https://www.instagram.com/jenniekwondesigns/',
    'https://www.facebook.com/jenniekwondesigns/',
  ];

  const normalizeHost = (host) => host.replace(/^www\./, '');

  const isExternalLink = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin); // handles relative URLs
      const linkHost = normalizeHost(linkUrl.hostname);
      const currentHost = normalizeHost(window.location.hostname);

      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');

      if (
        !href ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a') ||
        !isExternalLink(href)
      ) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkText = link.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          `${linkText}, Redirecting to a third-party website (opens in a new tab).`
        );
      }

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab).`
          : 'Redirecting to a third-party website (opens in a new tab).';

        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll(
      'a[href^="mailto:"], a[href^="tel:"]'
    );

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === '/' || window.location.pathname === '/index') return;

  const headings = document.querySelectorAll('h2.heading.heading--large');

  headings.forEach(h2 => {
    const h1 = document.createElement('h1');
    h1.className = h2.className;
    h1.innerHTML = h2.innerHTML;
    h2.replaceWith(h1);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll('h3.article-item__title.heading.h4');

  headings.forEach(h3 => {
    const h2 = document.createElement('h2');
    h2.className = h3.className;
    h2.innerHTML = h3.innerHTML;
    h3.replaceWith(h2);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('br, hr');

  elements.forEach(el => {
    el.setAttribute('aria-hidden', 'true');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const iframe = document.getElementById("PBarNextFrame");

    if (iframe) {
      iframe.setAttribute("title", "Next Content Frame");
    }
  }, 1000);
});

document.addEventListener("DOMContentLoaded",function(){
document.querySelectorAll(".image-with-text-block__content").forEach(function(section){
const heading=section.querySelector(".heading");
const button=section.querySelector(".button.button--primary");
if(!heading||!button)return;
const headingText=heading.textContent.trim().replace(/\s+/g," ");
if(headingText){
button.setAttribute("aria-label","Learn more about "+headingText.replace(/^Learn More About\s*/i,""));
}
});
});

/* [A11Y-FIX 2026-10-03] START: Consentmo cookie banner button target size (WCAG 2.5.5) - remove this block to revert */
(function () {
  const STYLE_ID = "a11y-csm-target-size";
  const CSS =
    ".cc-btn,[data-csm-button-type]{min-height:44px!important;min-width:44px!important;display:inline-flex!important;align-items:center;justify-content:center;box-sizing:border-box!important;}";

  function patch(host) {
    const root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function scan() {
    document.querySelectorAll("csm-cookie-consent").forEach(patch);
  }

  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
/* [A11Y-FIX 2026-10-03] END: Consentmo cookie banner button target size */
